export default "__VITE_ASSET__ZPLY6f7j__"